import {
  FileOutlined,
  SaveOutlined,
  RollbackOutlined,
  SearchOutlined,
  ClearOutlined,
  BarChartOutlined,
  EditOutlined,
  DeleteOutlined,
  PlayCircleOutlined,
  UploadOutlined,
  CloseCircleOutlined,
  InboxOutlined,
  PlusCircleFilled,
  DownloadOutlined,
  UserOutlined,
  MailOutlined,
  SettingOutlined,
  DropboxOutlined,
  CloseOutlined,
  ArrowLeftOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
  FileExcelOutlined,
  CopyOutlined,
  FilePdfOutlined,
  CheckCircleOutlined,
  StopOutlined,
  EyeOutlined,
  ExperimentOutlined,
  SyncOutlined,
  DoubleRightOutlined,
  CommentOutlined,
  PlusSquareOutlined,
  CaretUpOutlined,
  CaretDownOutlined
} from '@ant-design/icons';

export const ICON = {
  NEW    : <FileOutlined />,
  UPDATE : <SaveOutlined />,
  SAVE   : <SaveOutlined />,
  VIEW   : <SearchOutlined />, 
  SEARCH : <SearchOutlined />,
  RETURN : <RollbackOutlined />,
  CLEAR : <ClearOutlined />,
  REPORT : <BarChartOutlined />,
  EDIT : <EditOutlined />,
  DELETE : <DeleteOutlined />,
  PLAY : <PlayCircleOutlined />,
  UPLOAD: <UploadOutlined />,
  DOWNLOAD: <DownloadOutlined />,
  USER: <UserOutlined />,
  CANCEL: <CloseCircleOutlined />,
  DRAGGER: <InboxOutlined />,
  PLUS: <PlusCircleFilled />,
  MAIL: <MailOutlined />,
  SETTING: <SettingOutlined spin/>,
  DROPBOX: <DropboxOutlined />,
  CLOSE: <CloseOutlined />,
  ARROWLEFT: <ArrowLeftOutlined />,
  EDIT: <EditOutlined />,
  OPTION: <UnorderedListOutlined />,
  ORDER : <OrderedListOutlined />,
  EXCEL: <FileExcelOutlined />,
  COPY:<CopyOutlined/>,
  PDF: <FilePdfOutlined/>,
  CHECK: <CheckCircleOutlined/>,
  CANCEL: <StopOutlined/>,
  EYE: <EyeOutlined/>,
  EXPERIMENT: <ExperimentOutlined/>,
  SYNC: <SyncOutlined/>,
  NEXT: <DoubleRightOutlined/>,
  COMMENT: <CommentOutlined />,
  ADD_SQUARE: <PlusSquareOutlined />,
  UP: <CaretUpOutlined />,
  DOWN: <CaretDownOutlined />,
};